import styled from '@emotion/styled';
import BubbleMessage from './BubbleMessage';

export interface SystemMessageProps {}

const SystemMessageBox = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto 15px;
  text-align: center;
`;
const Bubble = styled(BubbleMessage)`
  padding: 8px 10px;
  color: #84868c;
  background: #f9f9f9;
  font-size: 12px;
`;

const SystemMessage: React.FC<SystemMessageProps> = ({ children }) => {
  if (!children) return null;
  return (
    <SystemMessageBox>
      <Bubble color="#F5F6F8">{children}</Bubble>
    </SystemMessageBox>
  );
};
export default SystemMessage;
